// Market (AU / UK) from the hostname, and everything that differs by market:
// phone, WhatsApp number, website, logo, booking domain, "From … a tape".
// *.co.uk → UK, everything else (incl. localhost) → AU.

export const MARKETS = {
  AU: {
    code: "AU",
    phoneDisplay: "+61 485 031 678",
    phoneHref: "tel:+61485031678",
    whatsapp: "61485031678",
    // Legal entity in the footer
    company: "Pinns Solutions Pty Ltd",
    website: "https://tapestodigital.com.au",
    logo: "https://tapestodigital.com.au/hubfs/logo_tapes_todigital%202.svg",
    booking: "https://booking.tapestodigital.com.au",
    currency: "$",
    dialCode: "+61",
    mobilePlaceholder: "4xx xxx xxx",
    postcodeLabel: "Postcode",
    suburbLabel: "Suburb",
    stateLabel: "State",
  },
  UK: {
    code: "UK",
    phoneDisplay: "+44 7361 588591",
    phoneHref: "tel:+447361588591",
    whatsapp: "447361588591",
    company: "Tape Conversions Pvt Ltd",
    website: "https://tapestodigital.co.uk",
    logo: "https://tapestodigital.co.uk/hubfs/logo_tapes_todigital%202.svg",
    booking: "https://booking.tapestodigital.co.uk",
    currency: "£",
    dialCode: "+44",
    mobilePlaceholder: "7xxx xxxxxx",
    postcodeLabel: "Postcode",
    suburbLabel: "Town",
    stateLabel: "County",
  },
};

// "From $24 a tape". Change it here only.
export const PRICE_FROM = {
  AU: "$24",
  UK: "£13",
};

export const marketCode = (hostname = window.location.hostname) =>
  hostname.slice(-6) === ".co.uk" ? "UK" : "AU";

export const market = () => MARKETS[marketCode()];

// The booking app for this market; VUE_APP_URL_BOOKING overrides it (dev)
export const bookingBase = () =>
  process.env.VUE_APP_URL_BOOKING || market().booking;

export const priceFrom = () => PRICE_FROM[marketCode()];
